import appConfig from "@/app.config";

// const schema = {
//   title: {
//     type: 'text',
//     label: 'News Title',
//     placeholder: 'Enter News Title',
//     required: true,
//     info: true,
//     character_count: 250,
//     tooltip: 'Title will be display on top',
//   },
//   date: {
//       type: 'date',
//       label: 'Date',
//       placeholder: 'Enter Date',
//       required: true,
//       info: true,
//       character_count: 0
//   },
//   upload_options: {
//     type: 'dep-select',
//     label: 'Upload Options',
//     placeholder: 'Select Upload Options',
//     options: ['Image', 'Video'],
//     required: false,
//     info: true,
//     character_count: 0,
//     children: {
//       image: {
//         type: 'file',
//         label: 'Image',
//         placeholder: '',
//         required: false,
//         info: true,
//         character_count: 0,
//         wrapper_class: 'col-6'
//       },
//       video: {
//         type: 'text',
//         label: 'Video URL',
//         placeholder: 'Enter Video URL',
//         required: false,
//         info: true,
//         character_count: 0,
//         wrapper_class: 'col-6'
//       },
//     }
//   },
//   description: {
//     type: 'ckeditor',
//     label: 'Description',
//     required: true,
//     info: false,
//     character_count: 2000
//   }
// };

const schema = {
  name: 'PCN News',
  tabs: [
    {
      title: 'News',
      meta: [{ name: "description", content: appConfig.description }],
      name: "News",
      activeBtn: true,
      addNewBtn: true,
      deleteBtn: true,
      addNewModalTitle: 'Add New Page',
      formData: {},
      schema: {
        name: {
          type: 'text',
          label: 'Page Title',
          placeholder: 'Enter Page Title',
          required: true,
          info: false,
          character_count: 50
        },
      },
      side_panel: {
        select_a_page: {
          type: 'list',
          label: 'Select News',
          placeholder: '',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: '',
          options: [],
          draggable: true
        }
      },
      form: {
        title: {
            type: 'text',
            label: 'News Title',
            placeholder: 'Enter News Title',
            required: true,
            info: true,
            character_count: 250,
            disabled: false,
            wrapper_class: ''
          },
        date: {
          type: 'date',
          label: 'Date',
          placeholder: 'Enter Date',
          required: true,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        featured: {
          type: 'toggle',
          label: 'Featured',
          placeholder: 'Enter Featured',
          required: false,
          info: true,
          character_count: 0,
          disabled: false,
          wrapper_class: 'col-6'
        },
        path: {
            type: 'text',
            label: 'Path',
            placeholder: 'Enter Path',
            required: false,
            info: true,
            character_count: 50,
            disabled: false,
            wrapper_class: ''
        },
        upload_options: {
            type: 'select',
            label: 'Upload Options',
            placeholder: '',
            required: false,
            info: true,
            character_count: 0,
            disabled: false,
            wrapper_class: 'col-6',
            options: [
              // 'Image', 
              'Video']
        },
        // image_url: {
        //     type: 'file',
        //     label: 'Image',
        //     placeholder: 'Select Image',
        //     required: false,
        //     info: true,
        //     character_count: 0,
        //     disabled: false,
        //     wrapper_class: ''
        // },
        video_url: {
            type: 'text',
            label: 'Video URL',
            placeholder: 'Enter Video URL',
            required: false,
            info: true,
            character_count: 0,
            disabled: false,
            wrapper_class: 'col-6'
        },
        description: {
          type: 'ckeditor',
          label: 'Description',
          placeholder: 'Enter Description',
          required: true,
          info: false,
          character_count: 2000,
          disabled: false,
          wrapper_class: ''
        },
      }
    }
  ]
};

const news = [
  {
    id: "news07092021",    
    active: true,
    title: "New Staff Member",
    text: "<p>Lorem ipsum dolor sit amet, consect adipiscing elit. Morbi in finibus mauris, eu varius mauris. Sed luctus ipsum non varius placerat.</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "new-staff-member.png",
    }
  },
  {
    id: "news07092021_2",    
    active: true,
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "service-added.png",
    }
  },
  {
    id: "news07092021_3",    
    active: true,
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "service-added.png",
    }
  }, 
  {
    id: "news07092021_4",    
    active: true,
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "service-added.png",
    }
  }, 
  {
    id: "news07092021_5",    
    active: true,
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "service-added.png",
    }
  }, 
  {
    id: "news07092021_6",    
    active: true,
    title: "Latest Service Added",
    text: "<p>At the present moment we have in total of 5 different services operation. The latest edition to the PCN 5 is dementia Care Nurse …</p>",
    additionalProp1: {
      featured: true,
      date: "07 Sep 2020",
      imageUrl: "service-added.png",
    }
  } 
]

export { schema, news };